import axios from 'axios';

function getTimezones () {
  return axios.get('api/timezones');
}

export {
  getTimezones
};



// WEBPACK FOOTER //
// ./src/services/TimezoneService.js